export default "__VITE_ASSET__DvFHFIu2__"